module.exports = __webpack_public_path__ + "img/logo_big.cbe04dda.png";